var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"relative"},[_vm._t("default"),_vm._v(" "),_c('div',{ref:"sticky",staticClass:"sticky-container"},[_vm._t("sticky")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }